import { PageTypeId } from '../../const';
import { ModCaowijer } from '../../../../components/Icons/ModCaowijer';
import { DefaultNavigationStrategy } from '../../defaults/strategy';

export class CommonNavigationStrategy extends DefaultNavigationStrategy {
	override getIcons() {
		const iconsOverride = {
			[PageTypeId.CaoNewsList]: ModCaowijer,
		};

		return Object.assign({}, super.getIcons(), iconsOverride);
	}
}
